module.exports = __webpack_public_path__ + "img/map.f2374e4c.png";